import { useTranslation } from "react-i18next"
import { TEXT_FALLBACK } from "ui-tools"
import { useCurrentCompanyContext } from "../components/AppShell/CurrentCompanyProvider"

type User = {
  first_name?: string | null
  last_name?: string | null
  username?: string | null
}

export const useFormatUser = () => {
  // TODO [error-handling-effort] https://jira.attensi.com/browse/WEB-18497
  const { t } = useTranslation()
  const {
    currentCompany: { userDisplayNameFormat },
  } = useCurrentCompanyContext()

  const formatUser = ({ username, first_name, last_name }: User): string => {
    if (username === "Anonymous" || first_name === "Anonymous")
      return t("ANONYMOUS")

    switch (userDisplayNameFormat) {
      case "username":
        return username || TEXT_FALLBACK
      case "firstname":
        return first_name || TEXT_FALLBACK
      case "firstname_and_lastname": {
        const fullName = [first_name, last_name].filter(Boolean).join(" ")
        return fullName || TEXT_FALLBACK
      }
    }
  }

  return formatUser
}
